/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.0
 */
import { ChangeEvent } from 'react';

import { IOptionItemProps } from '../../../../../components/common/Select/Select';

export enum ExtFilterAttrEnum {
    ACCESS = 'ACCESS',
    ACCOUNT = 'ACCOUNT',
    CONTRACT_NUMBER = 'CONTRACT_NUMBER',
    DC_RULE = 'DC_RULE',
    LABEL = 'LABEL',
    NAME = 'NAME',
    NUMBER = 'NUMBER',
    NUMBER_TYPE = 'NUMBER_TYPE',
    PERSONAL_ACC = 'PERSONAL_ACC',
    POST = 'POST',
    STATUS = 'STATUS',
    TARIFF = 'TARIFF',
}

export enum ExtFilterOperatorsEnum {
    EQ = 'EQ',
    NE = 'NE',
    STARTS_WITH = 'STARTS_WITH',
}

export enum ExtFilterOperationsEnum {
    AND = 'AND',
    OR = 'OR',
}

export enum ExtFilterAttrTypeEnum {
    SELECT = 'SELECT',
    TEXT = 'TEXT',
}

export const SAVED_FILTERS = 'savedFilters';

export type IExtFilterMetaMap = { [K in ExtFilterAttrEnum]: IExtFilterMetaItem }

/**
 * @description External filter item props
 * @interface IExtFilterItem
 * @property {string} attr - params name
 * @property {ExtFilterOperationsEnum | null} operation - type of operation
 * @property {ExtFilterOperatorsEnum} operator - type of operators
 * @property {string} value - filter value
 * @property {string} valueName - filter name
 */
export interface IExtFilterItem {
    attr?: ExtFilterAttrEnum;
    operation?: ExtFilterOperationsEnum | null;
    operator?: ExtFilterOperatorsEnum;
    value?: string;
    valueName?: string;
}

/**
 * @description External filter props
 * @interface ISubscriberExtFilter
 * @property {string} condition
 * @property {string} id - id extFilter's settings
 * @property {string} idsFilter
 * @property {IExtFilterItem[]} items - filter name
 * @property {string} name - name extFilter's settings
 */
export interface ISubscriberMobileExtFilter {
    condition?: string;
    id: string;
    idsFilter?: string;
    items: IExtFilterItem[];
    name: string;
}

/**
 * @description Meta data item props
 * @interface IExtFilterMetaDataItem
 * @property {string} key - data key
 * @property {string} value - data value
 */
export interface IExtFilterMetaDataItem {
    key: string;
    value: string;
}

/**
 * @description Meta item props
 * @interface IExtFilterMetaDataItem
 * @property {string} attr - parameters name
 * @property {string} attrType - parameters type
 * @property {IExtFilterMetaDataItem} data - additional data for select options
 * @property {ExtFilterOperatorsEnum[]} operators - selected operators
 */
export interface IExtFilterMetaItem {
    attr: ExtFilterAttrEnum;
    attrType: ExtFilterAttrTypeEnum;
    data?: IExtFilterMetaDataItem[];
    operators: ExtFilterOperatorsEnum[];
}

/**
 * @description Load extFilter data interface
 * @property {ISubscriberMobileExtFilter} extFilter - selected filter
 * @property {ISubscriberMobileExtFilter[]} extFilterList - filter list
 * @property {IExtFilterMetaItem[]} extFilterMeta - filter props list
 */
export interface IExtFilterData {
    extFilter: ISubscriberMobileExtFilter;
    extFilterList: ISubscriberMobileExtFilter[];
    extFilterMeta: IExtFilterMetaItem[];
}

export type ExtFilterOnChangeTypes = IOptionItemProps | ChangeEvent<HTMLInputElement>

/**
 * @description Change filter item interface
 * @property {string} type - changed props
 * @property {number} index - filter item index
 * @property {ExtFilterOnChangeTypes} value - new value
 */
export interface IExtFilterItemValue {
    index: number;
    type: string;
    value?: ExtFilterOnChangeTypes;
}


